<template>
  <div class="receive-form">
    <div class="qr">
      <qrcode class="qr-img" v-if="address" :value="address" :options="{width:'100%'}"></qrcode>
    </div>

    <div class="f-group">
      <div class="f-title">{{$t('asset.depositAddress')}}</div>
      <div class="f-input-btn">
        <input type="text" readonly="true" :value="address" />
        <div class="btn" @click="onAddressCopy">{{$t("global.copy")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 参数
  methods: {
    onAddressCopy() {
      let that = this;
      that.$copyText(that.address).then(
        e => {
          that.$Message.success({
            background: true,
            duration: 3,
            content: that.$t("global.copySuccess")
          });
        },
        e => {
          that.$Message.error({
            background: true,
            duration: 3,
            content: that.$t("global.copyFail")
          });
        }
      );
    }
  },
  computed: {
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./AssetReceiveForm.less");
</style>